module.exports = __webpack_public_path__ + "img/company-honor-COC-20230510.ee2a42f6.jpg";